<template>
    <div id="game">
        <h1 id="title" class="text-center">Acrotwister</h1>
        <div id="timer">
            <p class="time" v-bind:class="{ red: seconds == 0 }">{{ minutes | two_digits }} : {{ seconds | two_digits }}</p>
        </div>
        <div id="time-input">
            <label for="timeInput">Time for move:</label>
            <input id="timeInput" type="text" v-model="timeMove" placeholder="0">
            <span>s</span>
        </div>
        <div id="rules">
            <button class="rules-btn" v-on:click="showRules" >Rules</button>
        </div>
        <div id="overlay" v-on:click="hideRules" v-bind:class="{ visibleBlock: rulesShown }">
            <div id="rules-overlay">
                <h2>Acrotwister Rules</h2>
                <hr>
                <p>Game is played in pairs <b>baser</b> and <b>flyer</b> and these pairs compete until the last pair, winning one is playing</p>
                <p>1. All pairs start in starting position which is: <b>front bird</b>, <b>throne</b> or <b>any AcroYoga pose.</b></p>
                <p>2. Then the time for the round could be set, initially it is 30 seconds and game starts with pushing <i>START</i> button.</p>
                <p>3. Pairs have given time to perform the move in the given conditions, without using the help of the other limbs and all previous connections stays on the place.
                    <br><i>Example:</i> Pair starts in front bird and after pressing <i>START</i>, moves are generated, <b>baser</b> has left leg and <b>flyer</b> right shoulder. Baser moves his left leg to right shoulder of the flyer without using any other limb and the right leg stays on the left hip of the flyer.</p>
                <p>4. After completion of the move <i>NEXT</i> button is pressed and new move is generated. All previous connections are kept.</p>
                <p>5. In case the pair has fallen down or didn't complete the move in given time pair is out of the game.</p>
                <p>6. Last pair standing wins the game.</p>
                <p><i>Enjoy the game!</i></p>

            </div>
        </div>
        <div id="wrapper" class="container">
            <div class="row">
                <div id="baser-box" class="col-sm-6 col-xs-6">
                    <p class="move">{{ baserMove }}</p>
                    <p class="role-title">BASER</p>
                </div>
                <div id="flyer-box" class="col-sm-6 col-xs-6">
                    <p class="move">{{ flyerMove }}</p>
                    <p class="role-title">FLYER</p>
                </div>
            </div>
            <button class="next-btn" v-on:click="setMoves">{{ buttonName }}</button class="next-btn">
            <button class="restart-btn" v-bind:class="{ visible: gameRunning }" v-on:click="restart"><i class="fas fa-redo-alt"></i></button>
        </div>
    </div>
</template>

<script>
    export default {
        data () {
            return {
                timeMove: 30, // in s
                buttonName: 'START',
                lr: ['left', 'right'],
                baserMoves: ['foot', 'hand'],
                flyerMoves: ['shin', 'foot', 'hip', 'shoulder', 'hand', 'leg'],
                baserMove: '-',
                flyerMove: '-',
                date: null,
                gameRunning: false,
                rulesShown: false,
                now: Math.trunc((new Date().getTime()) / 1000)
            }
        },
        mounted() {
            let self = this;
            window.setInterval(() => {
                self.now = Math.trunc((new Date()).getTime() / 1000);
            },1000);
        },
        computed: {
            seconds() {
                return (this.getDifference()) % 60;
            },
            minutes() {
                return Math.trunc((this.getDifference()) / 60) % 60;
            }
        },
        methods: {
            setMoves() {
                if(!this.gameRunning) {
                    this.gameRunning = true;
                }
                this.buttonName = 'NEXT';
                this.baserMove = this.generateMove(this.baserMoves);
                this.flyerMove = this.generateMove(this.flyerMoves);
                // reset timer, -20 because it makes one more sec
                this.date = Math.trunc((new Date().getTime() + parseInt(this.timeMove*1000) - 100) / 1000);
            },
            generateMove(moves) {
                var lrItem = this.lr[Math.floor(Math.random() * this.lr.length)];
                var item = moves[Math.floor(Math.random() * moves.length)];
                return lrItem + ' ' + item;
            },
            getDifference() {
                let diff = this.date - this.now;

                return diff <= 0 ? 0 : diff;
            },
            showRules() {
                this.rulesShown = true;
            },
            hideRules() {
                this.rulesShown = false;
            },
            restart() {
                this.gameRunning = false;
                this.baserMove = '-';
                this.flyerMove = '-';
                this.buttonName = 'START';
                this.date = null;
            }
        }
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">

    @import '../../static/_variables.sass';

    #wrapper {
        position: absolute;
        top: 50%;
        left:0;
        right:0;
        margin:0 auto;
        @media #{$tablet} {
            top: unset;
            bottom: 10%;
        }
        @media #{$phone} {
            top: unset;
            bottom: 5%;
        }
    }
    #title {
        position: absolute;
        top: 20px;
        left: 0px;
        right: 0px;
        @media #{$tablet-sm} {
            top: 10px;
            font-size: 30px;
            left: 10px;
            right: unset;
        }
        @media #{$phone} {
            top: 10px;
            font-size: 26px;
            left: 0;
            right: 0;
        }
    }
    #flyer-box, #baser-box {
        font-size: 36px;
        @media #{$tablet} {
            font-size: 28px;
        }
        @media #{$phone} {
            font-size: 24px;
        }
        .move {
            margin-bottom: 100px;
            font-size: 56px;
            letter-spacing: 2px;
            text-align: center;
            @media #{$tablet} {
                font-size: 48px;
            }
            @media #{$tablet-sm} {
                margin-bottom: 70px;
                font-size: 32px;
            }
        }
        .role-title {
            position: absolute;
            bottom: 5px;
            left: 0;
            right: 0;
            @media #{$tablet} {
                margin-top: 20px;
            }
        }
    }
    .next-btn {
        background: transparent;
        border: white 2px solid;
        border-radius: 5px;
        color: white;
        font-size: 30px;
        padding: 5px 10 px;
        cursor: pointer;
        @media #{$phone} {
            font-size: 26px;
        }
    }
    .restart-btn {
        display: none;
        border: none;
        background: transparent;
        color: white;
        cursor: pointer;
        font-size: 20px;
        margin: 10px;
    }

    #rules {
        position: absolute;
        top: 100px;
        right: 5%;
        @media #{$tablet-sm} {
            top: 70px;
            right: 30px;
        }
        @media #{$phone} {
            top: 10px;
            right: 10px;
        }
    }

    #overlay {
        display: none;
        background: rgba(0,0,0,0.8);
        z-index: 10;
        position: absolute;
        width: 100%;
        height:100%;
    }
    #rules-overlay {
        z-index: 11;
        position: absolute;
        top: 10%;
        left: 0;
        right: 0;
        margin: 0 auto;
        width: 80%;
        height: 80%;
        background: #efefef;
        border-radius: 2px;
        color: #333;
        padding: 20px;
        font-size: 20px;
        overflow: scroll;
        @media #{$phone} {
            top: 5%;
            padding: 10px;
            font-size: 18px;
            height: 90%;
            width: 90%;
        }
    }

    .rules-btn {
        background: transparent;
        border: white 2px solid;
        border-radius: 5px;
        color: white;
        font-size: 20px;
        padding: 5px 10;
        cursor: pointer;
        @media #{$phone} {
            font-size: 18px;
            padding: 2px 5;
        }
    }

    #timer {
        position: absolute;
        top: 15%;
        left:0;
        right:0;
        margin:0 auto;

        .time {
            font-size: 120px;
            @media #{$tablet-sm} {
                font-size: 80px;
            }
            @media #{$phone} {
                font-size: 70px;
            }
        }
        .red {
            color: #c6151b;
        }

        @media #{$tablet} {
            top: 10%;
        }
        @media #{$tablet-sm} {
            top: 15%;
        }
        @media #{$phone} {
            top: 20%;
        }

    }

    #time-input {
        position: absolute;
        top: 5%;
        right: 5%;
        input {
            background: $background-color;
            border: none;
            border-bottom: 2px solid white;
            color: white;
            text-align: right;
            width: 50px;
            font-size: 30px;
        }
        @media #{$tablet-sm} {
            top: 5px;
        }
        @media #{$phone} {
            top: 50px;
            left: 0;
            right: 0;
        }
    }

    .visible {
        display: inline;
    }

    .visibleBlock {
        display: block !important;
    }

    .col-xs-6 {
        width: 50%;
    }
</style>



// WEBPACK FOOTER //
// src/components/Game.vue